// removed by extract-text-webpack-plugin
module.exports = {"lozenge":"index__lozenge--2Vvws","value":"index__value--3fBYd","wrapper":"index__wrapper--1IZZZ","date":"index__date--1C2EE","time":"index__time--1wo_A"};


//////////////////
// WEBPACK FOOTER
// ./src/client/shared-components/LabeledLozenge/styles/index.scss
// module id = lSc5
// module chunks = 23